export function toJSON(val: unknown): string {
  return JSON.stringify(val)
}
